import type React from 'react';

import cn from 'classnames';

import { Tooltip } from '@mui/material';

import { FilterCustom, FilterNew } from '@shared/assets';
import type { Tag } from '@shared/types/common';
import { Checkbox, MenuDropdown, MenuItem, useCommonMenu } from '@shared/ui';

import * as st from './styles.module.scss';

interface Props {
	tags: Tag[];
	selected: number[];
	onChange: (tags: number[]) => void;
	id?: string;
}

export const Filter: React.FC<Props> = ({ tags, selected, onChange, id }) => {
	const { onOpen, setReferenceEl, referenceEl, popperEl, setPopperEl } = useCommonMenu();

	const getBadgeNumber = (): number => {
		const number = selected.length;
		return number;
	};

	const handleChange = (id: number) => {
		const selectedTags = [...selected];
		let updatedTags: number[] = [];
		const isSelected = !!selectedTags.find((tag) => tag === id);
		if (isSelected) {
			updatedTags = selectedTags.filter((tag) => tag !== id);
		} else {
			selectedTags.push(id);
			updatedTags = [...selectedTags];
		}
		onChange(updatedTags);
	};

	const isFilterActive = selected.length > 0;

	return (
		<div className={st.wrapper}>
			<Tooltip title="Фильтр" disableInteractive>
				<div
					id={id ?? 'openFilter'}
					className={cn(
						st.filter,
						isFilterActive && st.open,
						getBadgeNumber() > 0 && st.badgeNumber
					)}
					onClick={onOpen}
					ref={setReferenceEl}
				>
					<FilterNew />
					{getBadgeNumber() > 0 && <p className={st.badge}>{getBadgeNumber()}</p>}
				</div>
			</Tooltip>
			<MenuDropdown referenceEl={referenceEl} popperEl={popperEl} setPopperEl={setPopperEl}>
				{tags.map((tag) => (
					<MenuItem
						isActive={selected.indexOf(tag.id) > -1}
						key={tag.id}
						onClick={() => handleChange(tag.id)}
					>
						<Checkbox
							label={tag.title}
							onChange={() => handleChange(tag.id)}
							checked={selected.indexOf(tag.id) > -1}
						/>
					</MenuItem>
				))}
			</MenuDropdown>
		</div>
	);
};
